<ng-content select="ngx-dropzone-label"> </ng-content>
<img *ngIf="!canShowPreview" [src]="fileObj.imageSrc" width="100px" height="100px" />
<img *ngIf="canShowPreview" [src]="imageSrc" />
<div>
  <ngx-dropzone-remove-badge id="remove-badge" *ngIf="removable" (click)="_remove($event)"></ngx-dropzone-remove-badge>
  <ngx-dropzone-remove-badge *ngIf = "showDownload" id="download-badge" (click)="_download($event)"> </ngx-dropzone-remove-badge>
</div>
